import { validateEmail } from '../../utils/validations'
import * as types from '../actions/types'

const initialCustomerInfo = {
  actionFeedback: false,
  info: {
    first_name: '',
    last_name: '',
    email: '',
    country_code: '',
    phone: '',
  },
  customerEmailExists: false,
  emailVerificationInProgess: false,
}

const profile = (state = initialCustomerInfo, action) => {
  switch (action.type) {
    case types.UPDATE_CUSTOMER_EMAIL:
      return {
        ...state,
        info: {
          ...state.info,
          email: validateEmail(action.emailValue),
        }, // emailReducer('', action),
      }
    case types.SET_API_ACTION_FEEDBACK_PROFILE:
      return {
        ...state,
        actionFeedback: action.message,
      }
    case types.SET_CUSTOMER_INFO:
      return {
        ...state,
        info: action.infos,
      }
    case types.EMAIL_EXISTS_STATUS:
      return {
        ...state,
        customerEmailExists: action.customerEmailExists,
      }
    case types.EMAIL_STATUS_VERIFYING:
      return {
        ...state,
        emailVerificationInProgess: action.emailVerificationInProgess,
      }
    default:
      return state
  }
}

export default profile
